export default __webpack_public_path__ + "d7ce6c4c34e3dee8d8c41739efae62b7.png";